import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoItem.module.css";
import classNames from "classnames";

/**
 * View component. Used to display information on cards
 */
export function InfoItem({ label, description, children }) {
  return (
    <>
      {!children ? (
        <>
          <div className={classNames(styles.container)}>
            <div className={styles.label}>{label}</div>

            <div className={styles.description}>{description}</div>
          </div>
        </>
      ) : (
        <>
          <div
            className={classNames(styles.container, {
              [styles.children]: children !== "",
            })}
          >
            <div className={styles.label}>{label}</div>
            {children}
            <div className={styles.description}>{description}</div>
          </div>
        </>
      )}
      {/* <div
        className={classNames(styles.container, {
          [styles.children]: children !== "",
        })}
      >
        <div className={styles.label}>{label}</div>
        {children}
        <div className={styles.description}>{description}</div>
      </div> */}
    </>
  );
}

InfoItem.propTypes = {
  //Label for the item
  label: PropTypes.string,
  // Option prop to pass in things like btns or checkmarks
  children: PropTypes.node,
  // Description next to the label
  description: PropTypes.string,
};
